import React from 'react';

// Componente Spinner básico (utiliza classes CSS para animação)
function Spinner({ className = 'w-6 h-6' }) {
  return (
    <div 
      className={`animate-spin rounded-full border-4 border-t-4 border-indigo-200 border-t-indigo-600 ${className}`}
      role="status"
      aria-label="loading"
    >
      <span className="sr-only">Carregando...</span>
    </div>
  );
}

export default Spinner;